import PropTypes from "prop-types";
import { Redirect, Route, Switch } from "react-router-dom";

import AddCar from "../features/cars/AddCar";
import AddonDetails from "../features/addons/AddonDetails";
import Addons from "../features/addons/Addons";
import Cardetails from "../features/cars/Cardetails";
import Cars from "../features/cars/Cars";
import CheckPayment from "../features/payments/CheckPayment";
import CleanerStatusDetails from "../features/cleaner/components/CleanerStatusDetails";
import CleanerStatusList from "../features/cleaner/components/CleanerStatusList";
import CustomerApprovalRequests from "../features/customers/CustomerApprovalRequests";
import Customerdetails from "../features/customers/Customerdetails";
import Customers from "../features/customers/Customers";
import CustomerReservation from "../features/customers/CustomerReservation";
import CustomerResVehicleInfo from "../features/customers/CustomerResVehicleInfo";
import Dashboard from "../features/dashboard/Dashboard";
import ezpass from "../features/tracking/ezpass";
import BuyInsurancePage from "../features/insurance/components/BuyInsurancePage";
import InsuranceHub from "../features/insurance/components/InsuranceHub";
import LeavingToday from "../features/reservations/LeavingToday";
import Locations from "../features/cars/Locations";
import Rates from "../features/cars/rates";
import Reservation from "../features/reservations/Reservation";
import ResDetails from "../features/reservations/components/reservationDetails";
import ReservationTomorrow from "../features/reservations/ReservationTomorrow";
import ReturingToday from "../features/reservations/ReturingToday";
import CompSettings from "../features/settings/components/CompSettings";
import EmployeeDetailsPage from "../features/settings/components/employee/EmployeeDetailsPage";
import EmployeeFormPage from "../features/settings/components/employee/EmployeeFormPage";
import ShareGrow from "../features/shareGrow/components/ShareGrow";
import Tolls from "../features/tracking/Tolls";
import New from "../features/tracking/Tracking";
import User from "../features/user/User";
import { AddCoveragePage, CoverageAddedPage } from "../features/addCoverage";
import { CheckInPage } from "../features/checkin";
import { CheckOutPage } from "../features/checkout";

function InsuranceTabRedirect({ tab, location }) {
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    return <Redirect to={{ pathname: "/insurance", search: params.toString() }} />;
}

InsuranceTabRedirect.propTypes = {
    tab: PropTypes.string.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string,
    }).isRequired,
};

export default function AppRoutes() {
    return (
        <Switch>
            <Route path="/" exact component={Dashboard} />
            <Route path="/reservations" exact component={Reservation} />
            <Route path="/share-grow" exact component={ShareGrow} />
            <Route path="/customers" exact component={Customers} />
            <Route path="/cars" exact component={Cars} />
            <Route path="/cars/categories" exact component={Rates} />
            <Route path="/cars/locations" exact component={Locations} />
            <Route path="/track" exact component={New} />
            <Route path="/user/:id" component={User} />
            <Route path="/cardetails/:id" component={Cardetails} />
            <Route path="/cars/add" exact component={AddCar} />
            <Route path="/customers/:id" component={Customerdetails} />
            <Route path="/reservations/:id/add-coverage" component={AddCoveragePage} />
            <Route path="/reservations/:id/coverage-added" component={CoverageAddedPage} />
            <Route path="/reservations/:id/check-in" component={CheckInPage} />
            <Route path="/reservations/:id/check-out" component={CheckOutPage} />
            <Route path="/reservations/:id" component={ResDetails} />
            <Route path="/customer-reservation" component={CustomerReservation} />
            <Route path="/customer-reservation-vehicle" component={CustomerResVehicleInfo} />
            <Route path="/ezpass" component={ezpass} />
            <Route path="/pay" component={CheckPayment} />
            <Route path="/track/reservation-tomorrow" component={ReservationTomorrow} />
            <Route path="/track/leaving-today" component={LeavingToday} />
            <Route path="/track/returning-today" component={ReturingToday} />
            <Route path="/customer-approval-requests" component={CustomerApprovalRequests} />
            <Route path="/add-ons" exact component={Addons} />
            <Route path="/add-ons/details/:id" exact component={AddonDetails} />
            <Route path="/tolls" exact component={Tolls} />
            <Route path="/cleaner-status" exact component={CleanerStatusList} />
            <Route path="/settings" exact component={CompSettings} />
            <Route path="/settings/employees/new" exact component={EmployeeFormPage} />
            <Route path="/settings/employees/:id/edit" exact component={EmployeeFormPage} />
            <Route path="/settings/employees/:id" exact component={EmployeeDetailsPage} />
            <Route path="/cleaner-status/:id" exact component={CleanerStatusDetails} />
            <Route path="/insurance" component={InsuranceHub} />
            <Route path="/sell-insurance" exact component={BuyInsurancePage} />
            <Route
                path="/on-rent-coverage"
                render={({ location }) => <InsuranceTabRedirect tab="products" location={location} />}
            />
        </Switch>
    );
}
